import styled from 'styled-components';

// The classic look's column box (Nic 2026-10-24): main's StyledColumn as it
// was before the redesign.
const ClassicColumn = styled.div`
  width: 100%;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid #ddd;
  padding: 0.5rem;
  padding-bottom: 0;
  border-radius: 5px;

  & > div:first-child {
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px solid #ccc;
  }

  & > div:first-child p {
    margin-bottom: 0;
  }

  & > div.dragging-over {
    background: #eee;
  }

  & .list {
    flex: 1;
  }
`;

export default ClassicColumn;
